import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {CoreComponent} from "../core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../service/auth.service";
import {EuOtpCodeLoginType} from "../../interfaces/core.types";

@Component({
  selector: 'login-otp-email',
  templateUrl: './login-otp-email.component.html',
  styleUrls: ['./login-otp-email.component.css']
})
export class LoginOtpEmailComponent extends CoreComponent implements OnInit, OnDestroy {

  formGroup!: FormGroup;
  @Output() onStepComplete = new EventEmitter<number>;
  @Output() onEnteredContact = new EventEmitter<string>;
  email: string = "";
  visible: boolean = false;
  showValidation: boolean = false;

  constructor(
    protected authService: AuthService,
    protected router: Router,
    private fb: FormBuilder) {
    super();
  }

  override ngOnInit(): void {
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
    this.initForm();
  }

  /**
   * Destroy component.
   */
  override ngOnDestroy(): void {

  }

  initForm(): void {
    if (!this.formGroup) {
      this.formGroup = this.fb.group({
        email: ['', [Validators.required, Validators.email]]
      });
    }
  }

  handleStepComplete(): void {
    this.showValidation = true;
    if (this.formGroup?.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }
    const email = this.formGroup?.get('email')?.value;
    this.busy = true;


    this.authService.otpLoginInitiate(EuOtpCodeLoginType.EMAIL, email).subscribe({
      next: res => {
        this.busy = false;
        this.onEnteredContact.emit(email);
        this.onStepComplete.emit(3);
      },
      error: err => {
        // optionally handle error
        this.busy = false;
      }
    });
  }

  navigateToLogin() {
    this.router.navigate(['/login'])
  }

  navigateBack(){
    this.onStepComplete.emit(0);
  }
}
